interface CountdownTimerProps {
  formatted: string;
  label: string;
}

export function CountdownTimer({ formatted, label }: CountdownTimerProps) {
  if (!formatted) return null;

  return (
    <div className="flex flex-col items-center gap-2 px-4">
      <div
        aria-live="polite"
        aria-label={`Countdown: ${formatted}`}
        style={{
          fontFamily: 'var(--font-mono)',
          fontSize: 'var(--text-countdown)',
          fontWeight: 700,
          color: 'var(--color-text)',
          fontVariantNumeric: 'tabular-nums',
          letterSpacing: '0.05em',
          lineHeight: 1,
        }}
      >
        {formatted}
      </div>
      <p
        className="truncate text-center max-w-[280px]"
        style={{ fontSize: '14px', color: 'var(--color-text-secondary)' }}
      >
        {label}
      </p>
    </div>
  );
}
